'use client';

import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';
import { cn } from '@/lib/utils';

interface TextRevealProps {
  text: string;
  className?: string;
  as?: 'h1' | 'h2' | 'h3' | 'p' | 'span';
  delay?: number;
  stagger?: number;
}

export function TextReveal({
  text,
  className,
  as: Tag = 'h2',
  delay = 0,
  stagger = 0.03,
}: TextRevealProps) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  const words = text.split(' ');

  return (
    <Tag ref={ref} className={cn('overflow-hidden', className)}>
      {words.map((word, wordIndex) => (
        <span key={wordIndex} className="inline-block mr-[0.25em]">
          {word.split('').map((char, charIndex) => {
            const totalIndex =
              words.slice(0, wordIndex).join('').length + charIndex;
            return (
              <motion.span
                key={charIndex}
                className="inline-block"
                initial={{ clipPath: 'inset(100% 0 0 0)' }}
                animate={
                  isInView
                    ? { clipPath: 'inset(0% 0 0 0)' }
                    : { clipPath: 'inset(100% 0 0 0)' }
                }
                transition={{
                  duration: 0.5,
                  ease: [0.22, 1, 0.36, 1],
                  delay: delay + totalIndex * stagger,
                }}
              >
                {char}
              </motion.span>
            );
          })}
        </span>
      ))}
    </Tag>
  );
}
